module.exports = __webpack_public_path__ + "static/img/2.0bb6ae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Empresariales-Seguro-Colectivo/2.png
// module id = VpiX
// module chunks = 0